// Persistence entry points retain ID allocation and delegate the persisted transformations.
import { buildReportConfigurationPayload as mapPayload } from "./mapping/configurationMapping";
import type { BuildPayloadArgs, BuildPayloadResult } from "./mapping/configurationMapping";
export { rebindReportConfigurationPayload } from "./mapping/configurationMapping";

const makeGuid = () => {
    const cryptoApi = globalThis.crypto;
    if (cryptoApi?.randomUUID) return cryptoApi.randomUUID();
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (char) => {
        const rand = Math.random() * 16 | 0;
        const value = char === "x" ? rand : (rand & 0x3) | 0x8;
        return value.toString(16);
    });
};

function withLogicalId<T extends { logicalId?: string }>(value: T): T {
    return value.logicalId ? value : { ...value, logicalId: makeGuid() };
}

export function buildReportConfigurationPayload(args: BuildPayloadArgs): BuildPayloadResult {
    return mapPayload(withLogicalId, args);
}
